import type { SVGProps } from 'react';
const SvgLock1Regular = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1.1 -1.1 24 24" {...props}>
    <desc>{'Lock 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M4.769 8.856H17.03s1.363 0 1.363 1.363v9.537s0 1.363-1.363 1.363H4.77s-1.363 0-1.363-1.363V10.22s0-1.363 1.363-1.363M6.131 8.856V5.45a4.769 4.769 0 0 1 9.538 0v3.406M10.9 13.625v2.725"
    />
  </svg>
);
export default SvgLock1Regular;
